
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function UserOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
        <span className="loader" style={{ fontSize: 24 }}>Loading...</span>
      </div>
    );
  }
  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
